import { useNavigate } from 'react-router-dom';
import { HelpTypes } from '@pharmaplan/common';
import { genericFunction } from '../../AvailableWorkshift/useAvailableWorkshiftActions';
import strings from '../../../localization';
import { useAppDispatch } from '../../useAppDispatch';
import { IFromScreen, renderScreen } from '../../../actions/drawerActions';
import { Constants, ScreenTypes } from '../../../helpers/Constants';
import useDrawer from '../../useDrawer';
import usePharmaPlanInvitation from './usePharmaPlanInvitation';

type IMenuAction = { key: string; label: string; onClick: () => void };

export const menuActions = (
  showCreateWorkshift: genericFunction,
  editAction: genericFunction,
  incompatibleAction: genericFunction,
  viewListOfWorkshift: genericFunction,
  pharmaPlanInvitationAction: IMenuAction | null,
) =>
  [
    {
      key: '-1',
      label: strings.createWorkshift,
      onClick: showCreateWorkshift,
    },
    {
      key: '1',
      label: strings.incompatibleMatch,
      onClick: incompatibleAction,
    },
    {
      key: '2',
      label: strings.listOfWorkshifts,
      onClick: viewListOfWorkshift,
    },
    {
      key: '0',
      label: strings.edit,
      onClick: editAction,
    },
    ...(pharmaPlanInvitationAction ? [pharmaPlanInvitationAction] : []),
  ];

const usePharmacyProfileViewDetails = (
  pharmacyId: string,
  fromScreen?: IFromScreen,
  hasOwner?: boolean,
  back?: () => void,
  canSendInvite = false,
  canResumePorting = false,
  lastPPInviteSentAt: string | null = null,
) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { closeDrawer } = useDrawer();
  const { action: pharmaPlanInvitationAction } = usePharmaPlanInvitation({
    personnelId: pharmacyId,
    userType: HelpTypes.pharmacy,
    canSendInvite,
    canResumePorting,
    lastPPInviteSentAt,
  });

  const goToViewProfile = () =>
    () => {
      dispatch(
        renderScreen({
          screenType: ScreenTypes.profile,
          screenNumber: 1,
          pharmacyId,
          fromScreen,
          back,
        }),
      );
    };

  const showCreateWorkshift = (name: string) =>
    () => {
      dispatch(
        renderScreen({
          screenNumber: 1,
          back: goToViewProfile(),
          screenType: ScreenTypes.pharmacyList,
          pharmacyId,
          extraParameters: {
            name,
          },
        }),
      );
    };

  const goToEditPharmacyProfile = () => {
    dispatch(
      renderScreen({
        screenNumber: 3,
        fromScreen,
        screenType: ScreenTypes.profile,
        hasOwner,
        back,
      }),
    );
  };

  const goToIncompatibleMatches = () => {
    closeDrawer();
    navigate(Constants.paths.admin.updateIncompatibleMatch, {
      state: { pharmacyId },
    });
  };

  const showListOfWorkshifts = () =>
    () => {
      closeDrawer();
      navigate(Constants.paths.admin.listOfWorkshifts, {
        state: pharmacyId,
      });
    };

  return {
    actions: (name: string) =>
      menuActions(
        showCreateWorkshift(name),
        () =>
          goToEditPharmacyProfile(),
        () =>
          goToIncompatibleMatches(),
        showListOfWorkshifts(),
        pharmaPlanInvitationAction,
      ),
  };
};

export default usePharmacyProfileViewDetails;
